import styled from 'styled-components';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  confirmText: string;
  confirmColor: 'blue' | 'red' | 'black';
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  isOpen,
  title,
  description,
  confirmText,
  confirmColor,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onCancel}>
      <ModalBox>
        <CloseBorder onClick={onCancel} />
        <Title>{title}</Title>
        <Description>{description}</Description>
        <ButtonGroup>
          <ConfirmButton type="button" color={confirmColor} onClick={onConfirm}>
            {confirmText}
          </ConfirmButton>
          <CancelButton type="button" onClick={onCancel}>
            아니요
          </CancelButton>
        </ButtonGroup>
      </ModalBox>
    </Overlay>
  );
}

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 999;
`;

const CloseBorder = styled.div`
  width: 36px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 24px;
  background: #909090;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 16px auto;
  cursor: pointer;
`;

const ModalBox = styled.div`
  width: 100%;
  height: 238px;
  background: #fff;
  border-radius: 32px;
  background: linear-gradient(180deg, #f2f2f5 0%, #ededf2 100%);
  margin: 16px;
  padding: 8px 0 16px 0;
`;

const Title = styled.div`
  color: var(--Font-02_black, #111);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px; /* 130% */
  letter-spacing: -0.5px;
  margin-bottom: 4px;
  text-align: center;
`;

const Description = styled.div`
  color: #303030;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 146.667% */
  letter-spacing: -0.375px;
  text-align: center;
  margin-bottom: 24px;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 16px;
`;

const ConfirmButton = styled.button<{ color: 'blue' | 'red' | 'black' }>`
  flex: 1;
  padding: 14px;
  border-radius: 16px;
  color: #fff;
  border: none;
  background-color: ${({ color }) =>
    color === 'blue' ? '#314BF7' : color === 'red' ? '#EF0101' : '#111'};

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.4px;
`;

const CancelButton = styled.button`
  flex: 1;
  padding: 14px;
  border-radius: 16px;
  background: #fff;
  color: #111;
  border: none;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.4px;
`;
